import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
    version: VERSION,
    isLogin: false,
    isMisLogin: false,
    pageAccountType: '', // 当前页面是mis账号类型还是商家账号类型， 值为 'mis' 'biz'
    bizUser: {}, // 商家账号信息
    misUser: {}, // 商家账号
    bizAuthInfo: {}, // 商家账号权限信息
    fromPage: '',
    sfCustoms: null,
    unreadMap: {},
    jiuJingConfirmOrders: 0
}

const store = new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    strict: false
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js